export const AUTH_TOKEN_REQUEST_MESSAGE_TYPE = "getAuthToken";
export const AUTH_TOKEN_RESPONSE_MESSAGE_TYPE = "authToken";
export const AUTH_TOKEN_TIMEOUT_MS = 10_000;
export const AUTH_TOKEN_REFRESH_FALLBACK_INTERVAL_MS = 1000 * 60 * 5;
export const AUTH_TOKEN_REFRESH_LEAD_TIME_MS = 1000 * 60;
export const AUTH_TOKEN_REFRESH_MIN_INTERVAL_MS = 1000 * 5;

export interface AuthTokenMessage {
  type: typeof AUTH_TOKEN_RESPONSE_MESSAGE_TYPE;
  data: {
    token: string;
  };
}

export function getJwtExpiryMs(token: string): number | null {
  const payload = token.split(".")[1];
  if (!payload) {
    return null;
  }

  try {
    const normalizedPayload = payload.replace(/-/g, "+").replace(/_/g, "/");
    const decodedPayload = globalThis.atob(
      normalizedPayload.padEnd(Math.ceil(normalizedPayload.length / 4) * 4, "="),
    );
    const parsedPayload = JSON.parse(decodedPayload) as { exp?: unknown };

    if (typeof parsedPayload.exp !== "number" || !Number.isFinite(parsedPayload.exp)) {
      return null;
    }

    return parsedPayload.exp * 1000;
  } catch {
    return null;
  }
}

export function getNextAuthTokenRefreshDelayMs(token: string, nowMs = Date.now()): number {
  const expiryMs = getJwtExpiryMs(token);
  if (!expiryMs) {
    return AUTH_TOKEN_REFRESH_FALLBACK_INTERVAL_MS;
  }

  return Math.max(
    expiryMs - nowMs - AUTH_TOKEN_REFRESH_LEAD_TIME_MS,
    AUTH_TOKEN_REFRESH_MIN_INTERVAL_MS,
  );
}
